export enum StatsCardsTypes {
  PROGRAMMES_PENDING = 'Programmes Pending',
  TRANSFER_REQUEST_RECEIVED = 'Pending Transfers Received',
  PROGRAMMES_UNCERTIFIED = 'Programmes Certifiable',
  TRANSFER_REQUEST_SENT = 'Pending Transfers Sent',
  PROGRAMMES_CERTIFIED = 'Programmes Certified',
  CREDIT_BALANCE = 'Credit Balance',
  CREDIT_CERTIFIED = 'Credits Certified',

  PROGRAMMES = 'Programmes',
  CREDITS = 'Credits',
  CERTIFIED_CREDITS = 'Certified Credits',
  TOTAL_PROGRAMMES = 'Total Programmes',
  TOTAL_PROGRAMMES_SECTOR = 'Total Programmes: Sector',
  TOTAL_CREDITS = 'Total Credits',
  TOTAL_CREDITS_CERTIFIED = 'Total Credits Certified',
  PROGRAMME_LOCATIONS = 'Programme Locations',
  TRANSFER_LOCATIONS_INTERNATIONAL = 'Transfer Locations International',
}
